

export const GENERATE_IMAGE = 'GENERATE_IMAGE';
export const IMAGE_GENERATION_IN_PROGRESS = 'IMAGE_GENERATION_IN_PROGRESS';
export const GET_IMAGE_GENERATED = 'GET_IMAGE_GENERATED';
